/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/randomInt */
function t(o){return Math.floor(Math.random()*Math.floor(o))}export{t as getWeakRandomInt};
//# sourceMappingURL=randomInt.mjs.map